<template>
  <main class="container main-location">
    <section class="wellcome-section">
      <img class="topic-icon" src="@/assets/images/location/home/topic_icon.svg" />
      <h1>Homes</h1>
      <p>
        Create a pleasant environment that allows family members to relax and <br />
        enjoy a refreshing atmosphere.
      </p>
      <div class="topic-tags">
        <span class="tag"> #Houses </span>
        <span class="tag"> #Apartments </span>
        <span class="tag"> #Villas </span>
        <span class="tag"> #etc </span>
      </div>
    </section>

    <img :src="require(`@/assets/images/location/home/main${mobileCheck ? '_mo' : ''}.png`)" class="main-img" alt="CESCO [BusinessSectors] Homes" />

    <section class="location-content">
      <section class="location-content-1">
        <h3>Are these concerns <br class="mo_show" />relevant to you?</h3>
        <div class="concerns-card-list">
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_pests.svg" alt="CESCO [BusinessSectors] Homes" />
            <div class="title">
              <h3>
                Concerns due to
                <br />
                Pests like Cockroaches and Ants
              </h3>
            </div>
            <p class="description">I want to live without worries from pests that appear often.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_virus.svg" alt="CESCO [BusinessSectors] Homes" />
            <div class="title">
              <h3>
                Invisible
                <br />
                Virus Threat
              </h3>
            </div>
            <p class="description">I’m looking for safe and verified management services to prevent transmission to my precious family.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_air.svg" alt="CESCO [BusinessSectors] Homes" />
            <div class="title">
              <h3>
                Enclosed Indoor
                <br />
                Air Management
              </h3>
            </div>
            <p class="description">With more time spent at home, I am worried about harmful substances in the invisible air.</p>
          </div>
        </div>
      </section>

      <section class="location-content-2">
        <h3>With CESCO, <br class="mo_show" />Find Your Solution.</h3>
        <div>
          <div class="border-content">
            <h4>We commit to transforming your living space into a secure environment free from pests.</h4>
            <p>
              Our service consultants visit to determine the fundamental causes of pest infestations and deliver CESCO's tailored 1:1 integrated pest
              management solution, which includes eradication and preventative measures to fully resolve pest issues.
            </p>
          </div>
          <div>
            <img src="@/assets/images/location/home/border_content_01.png" alt="CESCO [BusinessSectors] Homes" />
          </div>

          <div>
            <img src="@/assets/images/location/home/border_content_02.png" alt="CESCO [BusinessSectors] Homes" />
          </div>
          <div class="border-content">
            <h4>Enhance the safety of everyday spaces! Trust CESCO with your virus concerns.</h4>
            <p>
              Homes where masks are not worn require meticulous management due to higher susceptibility to virus transmission. Protect your family's
              health with our scientifically developed virus care solutions.
            </p>
          </div>
        </div>
      </section>
    </section>

    <section class="location-swiper">
      <div>
        <h3>
          CESCO’s Advanced Science Ensures 24/7
          <br />
          Management of Hazardous Elements Within Spaces
        </h3>

        <span class="swiper-navigation">
          <button type="button" class="me-swiper-button-prev" :disabled="prevDisabled" @click="slidePrev">
            <img src="@/assets/images/icons/Left Circle.svg" />
          </button>
          <button type="button" class="me-swiper-button-next" :disabled="nextDisabled" @click="slideNext">
            <img src="@/assets/images/icons/Right Circle.svg" />
          </button>
        </span>
      </div>

      <swiper ref="swiperRef" :slides-per-view="'auto'" :centered-slides="true" @slideChange="onSlideChange">
        <swiper-slide v-for="(item, index) in slildeList" :key="`product-slide-${index}`">
          <img :src="item.backgroundImg" alt="CESCO [BusinessSectors] Homes" />
          <button
            v-for="(productItem, productIndex) in item.products"
            :key="`product-slide-product-${productIndex}`"
            @click="handleButtonClick(productItem.productInfo)"
            :style="`
              top: ${mobileCheck ? productItem.mobilePosY : productItem.posY};
              left: ${mobileCheck ? productItem.mobilePosX : productItem.posX};
              transform: ${mobileCheck ? 'translate(-50%, -50%)' : 'none'};`"
          >
            <img src="@/assets/images/icons/add-icon-primary.svg" alt="" />
          </button>
        </swiper-slide>

        <button class="swiper-button-prev" :disabled="prevDisabled" @click="slidePrev"></button>
        <button class="swiper-button-next" :disabled="nextDisabled" @click="slideNext"></button>
      </swiper>
    </section>

    <section class="location-footer">
      <h3>
        Top 3 Solutions <br class="mo_show" />Most Requested by
        <br />
        Private Home
      </h3>
      <div class="solution-card-list">
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_total.svg" alt="CESCO [BusinessSectors] Homes" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Integrated
                  <br />
                  Pest Control
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Pest control for cockroaches, ants, and rats</p>
            </div>

            <router-link to="/solution/service/total"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_viruscare.svg" alt="CESCO [BusinessSectors] Homes" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Viruscare
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Manual disinfection and advanced equipment for 24-hour sterilization</p>
            </div>

            <router-link to="/solution/service/virusCare"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_air.svg" alt="CESCO [BusinessSectors] Homes" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Air Quality
                  <br />
                  Assurance
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">This solution manages everything from ultrafine particles to radon radiation to ensure safety.</p>
            </div>

            <router-link to="/solution/service/air"> Learn More </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>

  <LocationModalView :modal-state="modalState" @close-modal="closeModal" :productData="productData" />
</template>

<script setup>
import { inject, ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { useMeta } from 'vue-meta'
import { useSlide, useModal } from '@/hooks'
import LocationModalView from '@/components/common/LocationModalView.vue'

const { prevDisabled, nextDisabled, swiperRef, onSlideChange, slidePrev, slideNext } = useSlide()
const { modalState, openModal, closeModal } = useModal()

const mobileCheck = inject('mobileCheck')

const productData = ref({})

const slildeList = [
  {
    backgroundImg: require('@/assets/images/location/home/background_img_01.png'),
    products: [
      {
        posX: '36.375rem',
        posY: '15.4663rem',
        mobilePosX: '50%',
        mobilePosY: '40%',
        productInfo: {
          image: require('@/assets/images/location/home/product_img_01.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'Destroys viruses directly in the air with the Virus Pre-attack System<sup>TM</sup>. *Select an appropriate air sterilizer based on the spatial environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/home/background_img_02.png'),
    products: [
      {
        posX: '29.3125rem',
        posY: '18.7787rem',
        mobilePosX: '39%',
        mobilePosY: '60%',
        productInfo: {
          image: require('@/assets/images/location/home/product_img_01.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'Destroys viruses directly in the air with the Virus Pre-attack System<sup>TM</sup>. *Select an appropriate air sterilizer based on the spatial environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/home/background_img_03.png'),
    products: [
      {
        posX: '39.4375rem',
        posY: '22.2162rem',
        mobilePosX: '52.5%',
        mobilePosY: '60%',
        productInfo: {
          image: require('@/assets/images/location/home/product_img_02.png'),
          name: 'CESCO\nWater Smart-Fit Direct Water Purifier',
          description: 'Enhance your kitchen with a water purifier available in eight colors tailored to your personal taste.'
        }
      }
    ]
  }
]

/**
 * 슬라이드 버튼 클릭
 * @param {object} item
 */
const handleButtonClick = item => {
  productData.value = item
  openModal()
}

useMeta({
  title: 'CESCO - Homes',
  meta: [
    {
      vmid: 'description',
      name: 'description',
      content: 'Homes. Create a pleasant environment that allows family members to relax and enjoy a refreshing atmosphere.'
    }
  ]
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/location.scss';
</style>
